export const MESSAGE_ADD = 'MESSAGE_ADD';
export const MESSAGE_DELETE = 'MESSAGE_DELETE';
export const MESSAGE_BUTTON_CLICKED = 'MESSAGE_BUTTON_CLICKED';



// WEBPACK FOOTER //
// ../../src/messages/actionTypes.js